import {Button, Loading} from '@ds/components';
import {PageLayout} from '@ds/layout';
import historyEmptyState from 'assets/images/promotion-center/new/historyEmptyState.svg';
import Empty from 'common/empty/Empty';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from 'store';
import {getVendorProList} from 'store/slices/vendor-pro/thunk';

import {PRO_PAGE_SIZE, PRO_ROUTES} from '../constants';
import {getProVendorId} from '../utils';
import ProHistoryList from './components/ProHistoryList/ProHistoryList';

const ProList: React.FC = () => {
  const vendorId = getProVendorId();
  const [pagination, setPagination] = useState({pageSize: PRO_PAGE_SIZE, pageNumber: 1});
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {list: historyList, loading} = useAppSelector((state) => state.vendorPro);
  const items = historyList?.items ?? [];

  useEffect(() => {
    void dispatch(getVendorProList({vendor_id: vendorId as number, page_size: pagination.pageSize, page: 1}));
    // The first page is fetched once on mount, matching the previous list behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadMore = () => {
    void dispatch(
      getVendorProList({
        vendor_id: vendorId as number,
        page_size: pagination.pageSize,
        page: pagination.pageNumber + 1
      })
    );
    setPagination({pageSize: pagination.pageSize, pageNumber: pagination.pageNumber + 1});
  };

  if (!items.length && loading) {
    return (
      <div className="flex min-h-60 flex-1 items-center justify-center">
        <Loading size="large" />
      </div>
    );
  }

  return (
    <PageLayout
      footerPosition="static"
      contentId="pro-history-list"
      footer={
        <Button fullWidth onClick={() => navigate(PRO_ROUTES.add)}>
          فعال سازی سرویس پرو
        </Button>
      }
    >
      {items.length ? (
        <ProHistoryList
          items={items}
          totalItems={historyList?.total_items ?? 0}
          onLoadMore={loadMore}
        />
      ) : (
        <Empty illustration={historyEmptyState} className="min-h-60 flex-1 gap-1 px-4 text-center">
          <p className="text-subtitle-md text-neutral-fg">بسته‌ای برای نمایش وجود ندارد</p>
          <p className="text-body-sm text-gray-34">تا به حال سرویس پرو خود را فعال نکرده‌اید!</p>
        </Empty>
      )}
    </PageLayout>
  );
};

export default ProList;
